import { cn } from "@drpcrd/utils/shared";

type Props = {
  className?: string;
};

export const Divider = ({ className }: Props) => (
  <div role="separator" className={cn("bg-border-primary h-px", className)} />
);
